import { setRemoteDefinitions } from '@nx/angular/mf';
import { applicationRemotes } from './app/core/models/remotes';

new Promise<void>(resolve => {
  setRemoteDefinitions(applicationRemotes);
  resolve();
}).then(() => import('./bootstrap').catch(err => console.error(err)));
